export default __webpack_public_path__ + "static/media/ilvenerd.6ff8598f.png";